<script>
  'use strict'

  export let btnName, sectionTitle;
  let showPopup = false;

  // -------------------------------------------------
  function openPopup() {
    showPopup = true;
  }

  function closePopup() {
    showPopup = false;
  }
</script>

<button on:click="{openPopup}">{btnName}</button>

{#if showPopup}
  <div class="all-space glass-effect">
    <div class="pop-up glass-effect">
      <h3>{sectionTitle}</h3>
      <div class="main-content">
        <slot></slot>
      </div>
      <div class="close-btn">
        <button on:click="{closePopup}">CLOSE</button>
      </div>
    </div>
  </div>
{/if}

<style>
  h3 {
    text-align: center;
    margin: 0;
    border-bottom: 1px solid grey;
    padding: 12px;
  }

  .all-space {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: grid;
    place-items: center;
    width: 100%;
    height: 100%;
  }

  .pop-up {
    background: var(--section-color);
    margin: auto;
    border: 1px solid grey;
    min-width: 300px;
    border-radius: var(--border-radius);
  }

  .main-content {
    padding: 24px;
  }

  .close-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }

  .glass-effect {
    backdrop-filter: inherit;
    background: var(--section-color-alpha);
  }

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    .glass-effect {
      background-color: var(--section-color-alpha);
      -webkit-backdrop-filter: blur(12px);
      backdrop-filter: blur(12px);
    }
  }
</style>